import React, {FunctionComponent, ReactElement} from "react";
import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {KahunColorMap} from "fe-common/ui/assets/colorMap";
import {PaperProps} from "@mui/material/Paper/Paper";

//region [[ Styles ]]
interface StyledPaperProps extends PaperProps {
  flexdirection: "row" | "column";
  borderradius: string;
}

const DesktopExpandWrapper = styled("div")({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  height: "100%",
  width: "100%",
});

const BackButton = styled(ArrowBackIcon)({
  top: "50px",
  left: "-50px",
  fontSize: "xx-large",
  "&:hover": {
    color: KahunColorMap.Secondary,
  },
  cursor: "pointer",
});

const StyledPaper = styled(Paper)((props : StyledPaperProps) => ({
  display: "flex",
  boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12)",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "rgb(218, 220, 224)",
  borderRadius: props.borderradius,
  marginTop: "30px",
  marginBottom: "30px",
  flex: 1,
  flexDirection: props.flexdirection,
}));
//endregion [[ Styles ]]

//region [[ Props ]]
export interface ExpandLayoutProps {
  onClose?: () => void;
  flexDirection?: "row" | "column";
  borderRadius?: string;
  children?: React.ReactElement | React.ReactElement[];
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const DesktopExpandView: FunctionComponent<ExpandLayoutProps> = ({
  children,
  onClose,
  flexDirection = "row",
  borderRadius = "20px",
}) => {
  return (
    <DesktopExpandWrapper>
      <BackButton
        onClick={() => (onClose ? onClose() : window.history.back())}
      />
      <StyledPaper
        elevation={3}
        flexdirection={flexDirection}
        borderradius={borderRadius}
      >
        {children}
      </StyledPaper>
    </DesktopExpandWrapper>
  );
};

export default DesktopExpandView;
